import { Routes } from '@angular/router';
import { authGuard } from '@core/guards';
import { LayoutComponent } from '@layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'community-club-onboarding',
        pathMatch: 'full',
      },
      {
        path: 'error',
        loadChildren: () =>
          import('./routes/error/error.routes').then(m => m.routes),
      },
      {
        path: 'community-club-onboarding',
        loadChildren: () =>
          import('./routes/community-club-onboarding/community-club-onboarding.routes').then(
            m => m.routes
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'error/404',
  },
];
